import { useCallback } from 'react';
import { useOpenDeeplink } from '../../../../hooks';

export const useMoveToHome = () => {
  const { openDeeplink } = useOpenDeeplink();

  return useCallback(() => {
    openDeeplink('ably://home/today');
  }, [openDeeplink]);
};
